/*
 * CookieConsent - intégration pour Rails 6 / Webpack
 * Compatible vanilla-cookieconsent UMD
 * Affiche : Accepter tout / Tout rejeter / Laisse-moi choisir
 */

require('vanilla-cookieconsent/dist/cookieconsent.css');
require('vanilla-cookieconsent/dist/cookieconsent.umd.js');

window.initCookieConsentWrapper = function () {
  if (typeof window.initCookieConsent === 'function') {
    const cc = window.initCookieConsent();

    cc.run({
      current_lang: 'fr',

      gui_options: {
        consent_modal: {
          layout: 'box',
          position: 'bottom left',
          transition: 'slide'
        },
        settings_modal: {
          layout: 'box',
          transition: 'slide'
        }
      },

      languages: {
        fr: {
          consent_modal: {
            title: '🍪 Nous utilisons des cookies !',
            description:
              "Ce site utilise des cookies essentiels pour son bon fonctionnement, ainsi que des cookies analytiques afin d'améliorer votre expérience. Vous pouvez choisir vos préférences ci-dessous.",
            primary_btn: {
              text: 'Accepter tout',
              role: 'accept_all'
            },
            secondary_btn: {
              text: 'Tout rejeter',
              role: 'accept_necessary'
            },
            extra_btns: [
              {
                text: 'Laisse-moi choisir',
                role: 'settings'
              }
            ]
          },
          settings_modal: {
            title: 'Paramètres des cookies',
            save_settings_btn: 'Enregistrer les paramètres',
            accept_all_btn: 'Accepter tout',
            reject_all_btn: 'Tout rejeter',
            close_btn_label: 'Fermer',
            cookie_table_headers: [
              { col1: 'Nom' },
              { col2: 'Domaine' },
              { col3: 'Expiration' },
              { col4: 'Description' }
            ],
            blocks: [
              {
                title: 'Cookies nécessaires',
                description:
                  'Ces cookies sont essentiels pour assurer le bon fonctionnement du site web et ne peuvent pas être désactivés.',
                toggle: {
                  value: 'necessary',
                  enabled: true,
                  readonly: true
                }
              },
              {
                title: 'Cookies analytiques',
                description:
                  'Ces cookies nous permettent d’analyser la fréquentation du site afin d’améliorer son contenu.',
                toggle: {
                  value: 'analytics',
                  enabled: false,
                  readonly: false
                },
                cookie_table: [
                  {
                    col1: '^_ga',
                    col2: 'google.com',
                    col3: '2 ans',
                    col4: 'Google Analytics – identification des visiteurs.'
                  },
                  {
                    col1: '_gid',
                    col2: 'google.com',
                    col3: '24 heures',
                    col4: 'Google Analytics – statistiques de sessions.'
                  }
                ]
              }
            ]
          }
        }
      }
    });

    return cc;
  } else {
    console.error('❌ initCookieConsent non défini — vérifie le chargement du fichier UMD.');
    return null;
  }
};
